[
  {
    "product": "home",
    "name": "Edutin - Cursos gratis en línea",
    "id": 1,
    "slug": "",
    "description": "La página principal de Edutin, altamente posicionada en Google, donde se promocionan más de 6.000 cursos gratuito."
  },
  {
    "product": "about-us",
    "name": "Acerca de nosotros - Educar es compartir",
    "id": 2,
    "slug": "about-us",
    "description": "Una página institucional que refuerza la credibilidad de Edutin Academy. Úsala para conectar con audiencias que valoran la educación con propósito social."
  },
  {
    "product": "history",
    "name": "Edutin Academy - Nuestra historia",
    "id": 3,
    "slug": "history",
    "description": "Cuenta el origen e impacto de Edutin Academy. Ideal para promocionar donde desees transmitir confianza y trayectoria educativa."
  },
  {
    "product": "virtual-campus",
    "name": "Campus virtual",
    "id": 4,
    "slug": "virtual-campus",
    "description": "Edutin Academy es una plataforma de educación en línea que ofrece cursos gratuitos en diversas áreas del conocimiento. Con un enfoque en la calidad y accesibilidad, Edutin busca democratizar la educación y brindar oportunidades de aprendizaje a personas de todo el mundo."
  },
  {
    "product": "academy-contents",
    "name": "Como creamos nuestros cursos",
    "id": 5,
    "slug": "como-creamos-nuestros-cursos",
    "description": "Edutin Academy es una plataforma de educación en línea que ofrece cursos gratuitos en diversas áreas del conocimiento. Con un enfoque en la calidad y accesibilidad, Edutin busca democratizar la educación y brindar oportunidades de aprendizaje a personas de todo el mundo."
  },
  {
    "product": "helps/home",
    "name": "Centro de ayuda",
    "id": 6,
    "slug": "helps/home",
    "description": "Edutin Academy es una plataforma de educación en línea que ofrece cursos gratuitos en diversas áreas del conocimiento. Con un enfoque en la calidad y accesibilidad, Edutin busca democratizar la educación y brindar oportunidades de aprendizaje a personas de todo el mundo."
  }
]